<div
    class="chat-container"
    *ngIf="hasAiAssistEntitlement"
    [ngClass]="{ 'chat-open': showChatWindow, 'feature-panel-open': isFeaturePanelOpen }"
    [style.--feature-panel-width.px]="featurePanelWidth"
>
    <div class="chat-window" *ngIf="showChatWindow">
        <div class="chat-header">
            <h2>Trimble AI</h2>
            <button (click)="toggleChatInterface()" aria-label="Close Trimble AI chat">
                <i class="modus-icons" aria-hidden="true">close</i>
            </button>
        </div>
        <iframe
            #aiChatFrame
            class="ai-chat-iframe"
            title="Trimble AI Assistant"
            [src]="safeChatUiUrl"
            referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
    </div>
    <button class="btn btn-primary mb-2" *ngIf="!showChatWindow" (click)="toggleChatInterface()">
        <i class="modus-icons left-icon notranslate" aria-hidden="true">ai_stars</i>
        Ask Trimble AI
    </button>
</div>
